import "./home.css";

import React from "react";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { WhatsApp } from "@material-ui/icons";

import { ENTRY_POINT } from "../../utils/stateTypes";
import { getEntryPoint } from "../../utils/entryStorage";
import testimonialsData from "./testimonialsData";
// import Specials from "../sections/Specials";
// import specialsData from "./specialsData";
import Header from "../sections/Header";
import BlockGallery from "../sections/BlockGallery";
import CoverFlowGallery from "../sections/CoverFlowGallery";
import LineSeparator from "../sections/LineSeparator";
import BlockHeading from "../sections/BlockHeading";
import Testimonials from "../sections/Testimonials";
import GreenBlockSection from "../sections/GreenBlockSection";
import VideoSection from "../sections/VideoSection";
import ImageSection from "../sections/ImageSection";

const GALLERY_IMAGES_1 = {
  [ENTRY_POINT.DEFAULT]: [
    { src: "/images/gina-nick/SG_ginanick_01.jpg", alt: "A bride and groom on the terrace at Shepstone Gardens & The Great Hall" },
    { src: "/images/gina-nick/SG_ginanick_02.jpg", alt: "A bride on the stone balcony at Shepstone Gardens & The Great Hall" },
    { src: "/images/gina-nick/SG_ginanick_03.jpg", alt: "A bride and groom in the glass marquee at Shepstone Gardens & The Great Hall" },
    { src: "/images/gina-nick/SG_ginanick_04.jpg", alt: "A bride and groom at the altar at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_01.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_02.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_03.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_04.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_05.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_06.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_07.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_08.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_09.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_10.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_11.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_12.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_13.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_14.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_15.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_16.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_17.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_18.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_19.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_20.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_21.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_23.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_24.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_25.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_26.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_27.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_28.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_29.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_30.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_31.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_32.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_33.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_34.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_35.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_36.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_37.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_38.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_39.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_40.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_41.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_42.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_43.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_44.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set1/SG_home_set1_june_2026_46.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
  ],
  [ENTRY_POINT.CORPORATE]: [
    { src: "/images/corporate/Corporate_2.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_3.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_13.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_4.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_6.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_17.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_18.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_19.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
  ],
  [ENTRY_POINT.BLACK_DIAMOND]: [
    { src: "/images/bdiamond/Bdmnd_6.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_2.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_30.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_8.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_38.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_32.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_31.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_3.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_20.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_4.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_29.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_14.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_6.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_21.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_16.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_27.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
  ],
  [ENTRY_POINT.LOVE_IS_LOVE]: [
    { src: "/images/loveislove/LoveIsLove_3.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_15.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_10.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_17.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_20.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_29.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_5.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_4.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_19.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_6.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_30.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_14.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_13.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_18.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_4.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_19.jpg", alt: "A beautiful wedding setup for a same-sex marriage at Shepstone Gardens & The Great Hall" },
  ],
};

const GALLERY_IMAGES_2 = {
  [ENTRY_POINT.DEFAULT]: [
    { src: "/images/home/set2/SG_home_set2_june_2026_02.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_03.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_04.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_05.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_06.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_07.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_08.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_09.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_10.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_12.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_13.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
    { src: "/images/home/set2/SG_home_set2_june_2026_14.jpg", alt: "A wedding at Shepstone Gardens & The Great Hall" },
  ],
  [ENTRY_POINT.CORPORATE]: [
    { src: "/images/corporate/Corporate_20.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_21.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_15.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_7.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_24.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_18.jpg", alt: "A beautiful corporate event setup at Shepstone Gardens & The Great Hall" },
  ],
  [ENTRY_POINT.BLACK_DIAMOND]: [
    { src: "/images/bdiamond/Bdmnd_23.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_31.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_36.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_26.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_25.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/bdiamond/Bdmnd_5.jpg", alt: "A newly married African couple at Shepstone Gardens & The Great Hall" },
  ],
  [ENTRY_POINT.LOVE_IS_LOVE]: [
    { src: "/images/loveislove/LoveIsLove_2.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_20.jpg", alt: "A beautiful same-sex marriage venue at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_7.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_21.jpg", alt: "A beautiful same-sex marriage venue at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_21.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_24.jpg", alt: "A beautiful same-sex marriage venue at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_1.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_15.jpg", alt: "A beautiful same-sex marriage venue at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_9.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/corporate/Corporate_18.jpg", alt: "A beautiful same-sex marriage venue at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_16.jpg", alt: "A same-sex marriage couple at Shepstone Gardens & The Great Hall" },
    { src: "/images/loveislove/LoveIsLove_27.jpg", alt: "A beautiful same-sex marriage venue at Shepstone Gardens & The Great Hall" },
  ],
};

const COVER_IMAGE = {
  [ENTRY_POINT.DEFAULT]: [
    "/images/SG_home_banner_16.jpg",
  ],
  [ENTRY_POINT.CORPORATE]: [
    "/images/corporate/Corporate_1.jpg",
  ],
  [ENTRY_POINT.BLACK_DIAMOND]: [
    "/images/bdiamond/Bdmnd_2.jpg",
  ],
  [ENTRY_POINT.LOVE_IS_LOVE]: [
    "/images/loveislove/LoveIsLove_8.jpg",
  ],
};

// Focal point of the cover image when cropped (defaults to centre)
const COVER_IMAGE_POSITION = {
  [ENTRY_POINT.DEFAULT]: "center top",
};

const WELCOME_MESSAGE = {
  [ENTRY_POINT.DEFAULT]: [
    "A venue for life's best occasions: the pinnacle of sophistication and grace...",
  ],
  [ENTRY_POINT.CORPORATE]: [
    "Looking for a corporate function venue? We're happy to say: you've found it.",
  ],
  [ENTRY_POINT.BLACK_DIAMOND]: [
    "Now is YOUR time. Make your mark at Johannesburg's most exclusive wedding venue.",
  ],
  [ENTRY_POINT.LOVE_IS_LOVE]: [
    "Love is love. We are proud to be Johannesburg's most inclusive wedding venue.",
  ],
};

const styles = {
  followButton: {
    fontSize: "1.5em",
    width: "100%",
    height: "100%",
    textTransform: "none",
  },
  specialButton: {
    fontSize: "1.2em",
    textTransform: "none",
    padding: "5px 30px",
  },
};

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"A magnificent group of venues where special occasions are nurtured into unforgettable moments to be cherished forever."}
        ></meta>
      </Helmet>
      
      <ImageSection
        mainImg={"/images/Spa-Banner-2.jpg"}
        hrefLink={"https://www.shepstonespa.co.za/"}
      />
      <div className={"header-section-home-page"}>
        <Header
          bgImg={COVER_IMAGE[getEntryPoint()]}
          bgStyle={COVER_IMAGE_POSITION[getEntryPoint()] ? { objectPosition: COVER_IMAGE_POSITION[getEntryPoint()] } : null}
          // logo={"/images/TSE-Logo-White2.png"}
          headText={"THE SHEPSTONE EXPERIENCE"}
          overlayOpacity={0.25}
        />
      </div>

      {/* <LineSeparator noLine />
      <Specials specialsList={specialsData} /> */}

      <LineSeparator noLine />
      <BlockHeading
        headText={WELCOME_MESSAGE[getEntryPoint()]}
        noBorder
      />
      <LineSeparator noLine />
      
      <BlockGallery
        images={GALLERY_IMAGES_1[getEntryPoint()]}
      />

      <div className={"home-follow-button"}>
        <Button
          href={"https://www.instagram.com/shepstone_gardens/"}
          target={"_blank"}
          variant={"outlined"}
          color={"primary"}
          style={styles.followButton}
        >
          Follow us
        </Button>
      </div>

      {/* <GreenBlockSection
        headText={"Special"}
        subHeadText={"100 days of love"}
      >
        <div className={"event-item"}>
          <img
            src={"/images/100-days-of-love-special-2.jpg"}
            alt={"100 Days of Love Special at Shepstone Gardens & The Great Hall"}
            className={"standard-box"}
          />

          <div className={"event-intro-text"}>
            <h3>Let's get started on your Shepstone Gardens wedding!</h3>
          </div>
          
          <Button
            href={"https://wa.me/27678170890"}
            target={"_blank"}
            variant={"outlined"}
            color={"primary"}
            style={styles.specialButton}
            startIcon={<WhatsApp />}
          >
            Message us to find out more
          </Button>
        </div>
      </GreenBlockSection> */}

      <LineSeparator noLine />
      <LineSeparator noLine />
      <LineSeparator noLine />

      <GreenBlockSection
        headText={"your unique event"}
        subHeadText={"Our venue,"}
      >
        <div className={"three-columns"}>
          <p className={"venue-intro-text"}>
            Defined by our careful attention to detail, service and coordination, The Shepstone Experience offers timelessly stylish and sophisticated venues, perfect for your wedding, event or corporate occasion. You have a beautiful story to tell, and we are here to help you write this chapter.
          </p>
          <p className={"venue-intro-text"}>
            Our incredible team of industry-leading professionals are here to ensure that your event is stress-free and flawless, with an in-house team that will take care of every single one of your unique needs and bring your dream day to life. No vision is too big for us to help you execute.
          </p>
          <p className={"venue-intro-text"}>
            Being a family-owned venue, Shepstone Gardens gives all of our wonderful guests a warm welcome and a service that is personalised. When you arrive at Shepstone Gardens, you become part of our family, and we are there to take care of you every step of the way.
          </p>
        </div>
      </GreenBlockSection>

      <LineSeparator noLine />
      <LineSeparator noLine />

      <VideoSection
        videoUrl={"https://www.youtube.com/embed/wvH9XEyYeB0?si=IKlYO0NjO0prXqO-"}
        headText={"Like no other..."}
        previewImg={"/images/Home-Page-Video-Tile.jpg"}
        noLines
      />

      <BlockHeading
        headText={"Reviews"}
        noBorder
      />
      <Testimonials testList={testimonialsData} />

      <CoverFlowGallery
        images={GALLERY_IMAGES_2[getEntryPoint()]}
      />

    </div>
  );
};

export default Home;

